import gql from "graphql-tag";

export const MY_HR_GET_MARITAL_STATUSES = gql`
  query maritalStatuses {
    maritalStatuses {
      code
      name
    }
  }
`;
